import React from 'react';
import { Link } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import PageSEO from '@/components/PageSEO';

const AgbPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* SEO Meta Tags */}
      <PageSEO
        title="AGB | Allgemeine Geschäftsbedingungen - Handwerkernotdienst NRW"
        description="Allgemeine Geschäftsbedingungen (AGB) der Handwerkernotdienst NRW. Vertragsbed ingungen für Notdienst-Leistungen."
        canonicalUrl="https://handwerkernotdienst.nrw/agb"
        breadcrumbs={[
          { name: 'Start', url: 'https://handwerkernotdienst.nrw/' },
          { name: 'AGB', url: 'https://handwerkernotdienst.nrw/agb' }
        ]}
      />
      
      <Header />

      <section className="py-16" data-testid="agb-content">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8" data-testid="agb-title">Allgemeine Geschäftsbedingungen (AGB)</h1>
          
          <div className="prose prose-lg max-w-none">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Geltungsbereich</h2>
            <p className="text-gray-700 mb-6">
              Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge zwischen der Schössow Dienstleistungen UG (haftungsbeschränkt), 
              Handwerkernotdienst NRW (nachfolgend "Auftragnehmer" genannt) und dem Kunden („Auftraggeber") über die Erbringung von 
              Handwerkerdienstleistungen im Notdienst.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">2. Vertragsschluss</h2>
            <p className="text-gray-700 mb-4">
              Der Vertrag kommt durch die Beauftragung des Auftraggebers (telefonisch, per E-Mail oder über das Kontaktformular) 
              und die Bestätigung durch den Auftragnehmer zustande. Bei Notfällen erfolgt die Bestätigung durch die Entsendung 
              eines Technikers.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">3. Leistungsumfang</h2>
            <p className="text-gray-700 mb-4">
              Der Auftragnehmer erbringt Handwerkerdienstleistungen im Notdienst in folgenden Bereichen:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
              <li>Schlüsseldienst und Türöffnungen</li>
              <li>Elektro-Notdienst</li>
              <li>Sanitär- und Heizungsnotdienst</li>
              <li>Rohrreinigung</li>
              <li>Glas-Notdienst und Notverglasung</li>
              <li>Einbruchschutz und Sicherheitstechnik</li>
            </ul>
            <p className="text-gray-700 mb-6">
              Der genaue Leistungsumfang wird im Einzelfall nach Begutachtung der Situation vor Ort mit dem Auftraggeber abgestimmt.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">4. Vergütung</h2>
            <p className="text-gray-700 mb-6">
              Die Vergütung richtet sich nach dem konkreten Aufwand und wird vor Beginn der Arbeiten mit dem Auftraggeber abgestimmt. 
              Die Berechnung erfolgt transparent und nachvollziehbar. Bei Notdiensteinsätzen außerhalb der regulären Geschäftszeiten 
              (nachts, an Wochenenden und Feiertagen) können Zuschlaege anfallen, die dem Auftraggeber vor Beginn der Arbeiten 
              mitgeteilt werden.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">5. Zahlungsbedingungen</h2>
            <p className="text-gray-700 mb-6">
              Die Zahlung erfolgt in der Regel sofort nach Leistungserbringung in bar oder per EC-Karte. 
              Bei umfangreicheren Arbeiten kann nach Absprache eine Rechnung mit einem Zahlungsziel von 14 Tagen erstellt werden.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">6. Pflichten des Auftraggebers</h2>
            <p className="text-gray-700 mb-4">
              Der Auftraggeber ist verpflichtet:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
              <li>Dem Techniker Zugang zum Einsatzort zu verschaffen</li>
              <li>Bei Türöffnungen seine Berechtigung nachzuweisen (Ausweis, Mietvertrag o. ä.)</li>
              <li>Alle relevanten Informationen zum Notfall wahrheitsgemäß mitzuteilen</li>
              <li>Gefährdungen und besondere Umstände vor Ort zu melden</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">7. Haftung</h2>
            <p className="text-gray-700 mb-6">
              Der Auftragnehmer haftet für Schäden, die auf vorsätzlichem oder grob fahrlässigem Verhalten beruhen. 
              Bei leichter Fahrlässigkeit haftet der Auftragnehmer nur bei Verletzung wesentlicher Vertragspflichten. 
              Die Haftung ist in diesem Fall auf den vorhersehbaren, vertragstypischen Schaden begrenzt.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">8. Gewährleistung</h2>
            <p className="text-gray-700 mb-6">
              Für die erbrachten Leistungen gelten die gesetzlichen Gewährleistungsfristen. 
              Bei Mängeln ist der Auftraggeber verpflichtet, den Auftragnehmer unverzüglich zu informieren und ihm Gelegenheit 
              zur Nachbesserung zu geben.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">9. Stornierung</h2>
            <p className="text-gray-700 mb-6">
              Sollte der Auftraggeber einen bereits beauftragten Einsatz stornieren, nachdem der Techniker bereits auf dem Weg ist, 
              behält sich der Auftragnehmer vor, die entstandenen Anfahrtskosten in Rechnung zu stellen.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">10. Datenschutz</h2>
            <p className="text-gray-700 mb-6">
              Der Auftragnehmer verpflichtet sich, alle im Rahmen der Auftragsabwicklung bekannt gewordenen personenbezogenen Daten 
              gemäß den geltenden Datenschutzbestimmungen zu behandeln. Nähere Informationen finden Sie in unserer{' '}
              <Link to="/datenschutz" className="text-[#0066cc] hover:underline">Datenschutzerklärung</Link>.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">11. Streitbeilegung</h2>
            <p className="text-gray-700 mb-6">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#0066cc] hover:underline">
                https://ec.europa.eu/consumers/odr/
              </a><br />
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">12. Schlussbestimmungen</h2>
            <p className="text-gray-700 mb-6">
              Es gilt das Recht der Bundesrepublik Deutschland. Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, 
              berührt dies die Wirksamkeit der übrigen Bestimmungen nicht.
            </p>

            <p className="text-gray-600 text-sm mt-8">
              Stand: {new Date().toLocaleDateString('de-DE', { year: 'numeric', month: 'long' })}
            </p>

            <div className="mt-8 p-6 bg-gray-50 rounded-xl">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Kontakt bei Fragen</h3>
              <p className="text-gray-700">
                Bei Fragen zu unseren AGB erreichen Sie uns unter:<br />
                Telefon: <a href="tel:+4923139083687" className="text-[#0066cc] hover:underline">+49 231 39083687</a><br />
                E-Mail: <a href="mailto:info@handwerkernotdienst.nrw" className="text-[#0066cc] hover:underline">info@handwerkernotdienst.nrw</a>
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AgbPage;
